import React from 'react';

const Loader = () => (
    <div className="kognetics-loader">}</div>
)

export default Loader;
